export type DocumentPart =
  | { kind: "text"; value: string; index: number }
  | { kind: "document"; value: string; closed: boolean; index: number };

const OPEN = /^<<HEREDOC\s*$/m;
const CLOSE = /^HEREDOC\s*$/m;

export const splitDownloadableDocuments = (content: string): DocumentPart[] => {
  const parts: DocumentPart[] = [];
  let rest = content;
  let index = 0;
  while (rest) {
    const open = rest.match(OPEN);
    if (!open || open.index == null) {
      parts.push({ kind: "text", value: rest, index: index++ });
      break;
    }
    const before = rest.slice(0, open.index);
    if (before) parts.push({ kind: "text", value: before, index: index++ });
    const documentStart = open.index + open[0].length;
    const afterOpen = rest.slice(documentStart).replace(/^\r?\n/, "");
    const close = afterOpen.match(CLOSE);
    if (!close || close.index == null) {
      parts.push({
        kind: "document",
        value: afterOpen,
        closed: false,
        index: index++,
      });
      break;
    }
    parts.push({
      kind: "document",
      value: afterOpen.slice(0, close.index).replace(/\r?\n$/, ""),
      closed: true,
      index: index++,
    });
    rest = afterOpen.slice(close.index + close[0].length).replace(/^\r?\n/, "");
  }
  return parts;
};
